<template>
  <div class="container o-html-block">
    <div class="row">
      <div class="col-12">
        <div v-html="content.hTML" />
      </div>
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';

export default {
  name: 'HtmlBlock',
  mixins: [contentMixin]
};
</script>
